export const validateProductFormData = (productFormData, sectionData) => {
    //------
    if (productFormData.counterpartyType &&
        productFormData.name &&
        (productFormData.price === 0 || productFormData.price) &&
        productFormData.turnAroundTime && productFormData.productCategory &&
        productFormData.reportCategory && productFormData.reportFrontCover &&
        (sectionData.length > 0) && (productFormData.standardProduct && productFormData.standardProductCategory && productFormData.standardProductSegment)) {
        return true
    } else {
        return false
    }
}

export const sectionDataTransform = (sectionData) => {
    let data = sectionData.map((item, index, element) => {
        let tempSectionData = Object.assign({});
        tempSectionData.name = item.label;
        tempSectionData.id = item.value;
        tempSectionData.tags = item.tags;
        return tempSectionData;
    })
    return data
}

export const crawlerSelectionTransform = (sectionData) => {
    let data = sectionData.map((item, index, element) => {
        let tempSectionData = Object.assign({});
        tempSectionData.name = item.label;
        tempSectionData.id = item.value
        return tempSectionData;
    })
    return data
}

export const prepareCrawlerRequestData = (crawlerData) => {
    if(crawlerData == null || !crawlerData){
        return [];
    }
    let data = crawlerData.map((item) => item.id);
    return data
}


export const  prepareCrawlerData = (crawlerData) => {
    if(crawlerData == null || !crawlerData ){
        return [];
    }
    let data = crawlerData.map((item, index, element) => {
        let tempCrawlerData = Object.assign({});
        tempCrawlerData.name = item;
        tempCrawlerData.id = item;
        return tempCrawlerData;
    })
    return data
}